import { render, staticRenderFns } from "./core-agent.vue?vue&type=template&id=4564f97f&"
import script from "./core-agent.vue?vue&type=script&lang=js&"
export * from "./core-agent.vue?vue&type=script&lang=js&"
import style0 from "./core-agent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports